import React, { useState, useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { useTheme } from '@material-ui/core/styles'
import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import Card from '@material-ui/core/Card'
import CardHeader from '@material-ui/core/CardHeader'
import Typography from '@material-ui/core/Typography'
import BootstrapTable from 'react-bootstrap-table-next'
import Grid from '@material-ui/core/Grid'
import Loader from 'components/general/Loader'
import filterFactory, { textFilter, selectFilter, numberFilter } from 'react-bootstrap-table2-filter'

import componentStyles from 'assets/theme/views/admin/react-bs-table.js'

const useStyles = makeStyles(componentStyles)

function BuyersTable(props) {
    const classes = { ...useStyles() }

    const columns = [
        {
            dataField: 'name',
            text: 'Name',
            formatter: (cell, row) => {
                return (<Box className='hover-text primary-text'>{row.companyName} ({row.companyId.toUpperCase()})</Box>)
                
            }
        },
        {
            dataField: 'type',
            text: 'Type',
            //sort: true,
            formatter: (cell, row) => {
                return <>{row.type}</>
            }
        },
        {
            dataField: 'allocation',
            text: 'Allocation/Balance',
            //sort: true,
            formatter: (cell, row) => {
                return <>{row.type === 'Allocation' ? row.allocation + '/week (€' + row.leadPrice.toFixed(2) + ' per lead)' : '€' + row.balance.toFixed(2)}</>
            }
        },
        {
            dataField: 'delivered',
            text: 'Delivered',
            sort: true,
            formatter: (cell, row) => {
                return <>{row.leadCount || 0}</>
            }
        },
        {
            dataField: 'returns',
            text: 'Returned',
            sort: true,
            formatter: (cell, row) => {
                return <>{row.returnCount || 0}</>
            }
        }
    ]

    return (
        <Card>
            <>
                <CardHeader
                    subheader={
                        <>
                            <Box display='flex' style={{justifyContent: 'space-between'}}>
                                <Box>
                                    <Box
                                        component={Typography}
                                        variant='h2'
                                        marginBottom='0!important'
                                    >
                                        <Box component='span'>Active NPH Buyers</Box>
                                    </Box>
                                </Box>
                            </Box>
                        </>
                    }
                    classes={{ root: classes.cardHeaderRoot }}
                ></CardHeader>
                
                <div className='table-container'>
                    <BootstrapTable 
                        keyField='name' 
                        data={ props.buyers } 
                        columns={ columns } 
                        filter={ filterFactory() } 
                        noDataIndication={<Box>No active buyers</Box>}
                    />
                </div>
            </>
        </Card>
    );
}

export default BuyersTable